import React, { ReactElement, useState } from "react";
import { makeStyles } from "@material-ui/core";
import theme from "../../../themes";
import { RedirectUri, useEnumStrings } from "../../enumStrings";
import { UserType } from "../../../graphql/types";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Loader from "../../common/Loader/Loader";
import useIsChamber from "../../common/Hooks/useIsChamber";
import PerksLinkChamberList from "./ChamberList";
import VideoTutorialButton from "../../common/VideoTutorialButton";
import ExportButton from "../../common/ExportButton";
import { openInstructionPdf } from "../../common/openInstructionPdf";
import ComingSoonDialog from "../../common/ComingSoonDialog";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const useStyles = makeStyles((themes: any) => ({
  headerSection: {
    backgroundColor: theme.palette.primary.main,
    padding: "30px 40px",
    minHeight: "100px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    "@media (max-width: 768px)": {
      minHeight: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "20px 16px",
    },
  },
  headerTitle: {
    fontSize: "32px",
    color: "white",
    fontWeight: "bold",
    margin: "0",
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  headerDescription: {
    fontSize: "18px",
    color: "rgba(255, 255, 255, 0.9)",
    margin: "0",
    lineHeight: "1.5",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "1.55",
    },
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "8px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column" as const,
      alignItems: "stretch",
      gap: "8px",
      width: "100%",
      "& > div": { width: "100%", margin: 0 },
      "& > div > a, & > div > a > button, & > div > button, & > button, & > a": {
        width: "100%",
        marginTop: "0 !important",
        justifyContent: "center",
      },
    },
  },
  contentContainer: {
    backgroundColor: theme.palette.primary.main,
    padding: "0 40px 40px 40px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 0 20px 0",
    },
  },
  content: {
    display: "flex",
    background: "#FFFFFF",
    minHeight: "80vh",
    borderRadius: "16px",
    padding: "30px",
    [theme.breakpoints.down("sm")]: {
      padding: "20px",
    },
    flexDirection: "column",
    overflow: "hidden",
  },
}));

const PerksLink = (): ReactElement => {
  const classes = useStyles();
  const enumStrings = useEnumStrings();

  const headerInfo = // @ts-ignore
    enumStrings?.groups[UserType.ChamberAdmin][RedirectUri.perksLink];

  const isChamber = useIsChamber();
  const [comingSoonOpen, setComingSoonOpen] = useState(false);

  return (
    <div>
      <div className={classes.headerSection}>
        <h1 className={classes.headerTitle}>{headerInfo.title}</h1>
        <p className={classes.headerDescription}>
          {enumStrings.perksLink.linkYour}{" "}
          {isChamber
            ? enumStrings.perksLink.chambers
            : enumStrings.perksLink.boards}{" "}
          {enumStrings.perksLink.perks}
          {" "}{enumStrings.perksLink.description}
        </p>
        <div className={classes.buttonContainer}>
          <VideoTutorialButton
            tutorialUrl="https://share.synthesia.io/embeds/videos/d6873d08-2e6f-497c-b9f2-1e9a97806ccb"
          />
          <ExportButton
            customOnClick={() => openInstructionPdf("PerkLinks.pdf")}
            icon={<InfoOutlinedIcon style={{ color: theme.palette.primary.main, marginRight: "10px", width: "24px", height: "24px" }} />}
            label={enumStrings.manageMembersPage.viewInstructionsTab}
            disablePadding
          />
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
        />
      </div>

      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <PerksLinkChamberList />
        </div>
      </div>

      <ComingSoonDialog
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
      />
    </div>
  );
};

export default PerksLink;
